import {Component, input} from '@angular/core';

/** Centered faint text for empty lists; `variant="drop"` is the dashed drop zone. */
@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styles: `
        :host {
            display: block;
            padding: 20px 28px;
            text-align: center;
            font-size: 14px;
            color: #9aa0a6;
        }

        :host(.filled) {
            background: #fafbfb;
            border-radius: 8px;
        }

        :host(.drop) {
            padding: 18px 24px;
            font-size: 13px;
            border: 1px dashed #d6d8db;
            border-radius: 8px;
        }
    `,
    host: {
        '[class]': 'variant()'
    }
})
export class EmptyStateComponent {
    readonly variant = input<'plain' | 'filled' | 'drop'>('plain');
}
